import axios from "axios";
import store from "../store";

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || "";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.patch["Content-Type"] = "application/json";

// Зэрэг refresh хийгдэхээс сэргийлж, бүх caller-ууд НЭГ Promise-ыг хуваалцана
let refreshPromise = null;

async function refreshTokens(currentAccessToken, currentRefreshToken) {
  const { data } = await axios.post(
    "/api/enduser/refresh",
    { refreshToken: currentRefreshToken },
    {
      headers: { Authorization: `Bearer ${currentAccessToken}` },
      _isRefresh: true,
    },
  );
  store.commit("auth/setTokens", {
    accessToken: data.access_token,
    refreshToken: data.refresh_token,
  });
  return data.access_token;
}

// Аль хэдийн refresh ажиллаж байгаа бол түүнийг буцаана,
// эс бөгөөс шинэ refresh эхлүүлнэ. Бүх дуудагч (interval, 401-handler)
// яг ижил Promise-ыг хүлээх тул давхар refresh хийгдэхгүй.
async function getRefreshedToken() {
  if (refreshPromise) return refreshPromise;

  const accessToken = store.getters["auth/accessToken"];
  const refreshToken = store.getters["auth/refreshToken"];

  refreshPromise = refreshTokens(accessToken, refreshToken).finally(() => {
    refreshPromise = null;
  });

  return refreshPromise;
}

export default function setup(vue) {
  // Нөхцөлгүйгээр, тогтмол ажиллах refresh interval.
  // Token байхгүй үед зүгээр л алгасна (logout болгохгүй).
  setInterval(async () => {
    const accessToken = store.getters["auth/accessToken"];
    const refreshToken = store.getters["auth/refreshToken"];

    if (!accessToken || !refreshToken) return;

    try {
      await getRefreshedToken();
    } catch (err) {
      if (err.response?.status === 401) {
        store.dispatch("auth/logout");
        vue.$router.push("/user/login").catch(() => {});
      }
    }
  }, 60 * 1000);

  axios.interceptors.request.use(
    async (request) => {
      if (request._isRefresh) return request;

      const freshToken = store.getters["auth/accessToken"];
      if (freshToken && !request.noAuth && !request.headers["Authorization"]) {
        request.headers["Authorization"] = `Bearer ${freshToken}`;
      }
      return request;
    },
    (error) => Promise.reject(error),
  );

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const { response, config: originalRequest } = error;

      if (!response) {
        vue.$bvToast.toast("Connection Error", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
        return Promise.reject(error);
      }

      if (
        response.status === 401 &&
        !originalRequest.noAuth &&
        !originalRequest._retry &&
        !originalRequest._isRefresh
      ) {
        const refreshToken = store.getters["auth/refreshToken"];

        if (!refreshToken) {
          const wasAuthenticated = store.getters["auth/isAuthenticated"];
          store.dispatch("auth/logout");
          if (wasAuthenticated) {
            vue.$router.push("/user/login").catch(() => {});
          }
          return Promise.reject(error);
        }

        originalRequest._retry = true;

        try {
          const newToken = await getRefreshedToken();
          originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
          return axios(originalRequest);
        } catch (refreshError) {
          store.dispatch("auth/logout");
          vue.$router.push("/user/login").catch(() => {});
          return Promise.reject(refreshError);
        }
      }

      if (response.status >= 400 && response.status < 500) {
        if (response.data.errors) {
          for (const [, value] of Object.entries(response.data.errors)) {
            vue.$bvToast.toast(value[0], {
              title: "Алдаа гарлаа",
              variant: "danger",
            });
          }
        }
        // if (response.data && response.data.message) {
        //   vue.$bvToast.toast(response.data.message, {
        //     title: "Хүсэлт амжилтгүй",
        //     variant: "danger",
        //   });
        // }
      }

      if (response.status >= 500) {
        if (response.data.errors) {
          for (const [, value] of Object.entries(response.data.errors)) {
            vue.$bvToast.toast(value[0], {
              title: "Алдаа гарлаа [500]",
              variant: "danger",
            });
          }
        } else if (Array.isArray(response.data)) {
          response.data.forEach((err) => {
            vue.$bvToast.toast(
              typeof err === "string" ? err : JSON.stringify(err),
              { title: "Алдаа гарлаа [500]", variant: "danger" },
            );
          });
        } else {
          vue.$bvToast.toast(response.data, {
            title: "Алдаа гарлаа [500]",
            variant: "danger",
          });
        }
      }

      return Promise.reject(error);
    },
  );
}